import React from 'react'

import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from './Mui/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CustomTablePagination from './Mui/CustomTablePagination';
import Paper from '@material-ui/core/Paper';
import MobileFilters from './MobileFilters';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {table as styles} from './Mui/styles';
import moment from 'moment';

import Icon from '@material-ui/core/Icon';

import FilterSelect from './inputs/FilterSelect'
import CustomRangePicker from './inputs/CustomRangePicker'
import CustomTableHead from './CustomTableHead'
import Popover from './Mui/Popover'

class InstaTable extends React.Component {
  constructor() {
    super()
    this.picker = React.createRef()
    this.state={
      sort: 'created_at',
      order: 'desc',
      selected: [],
      per_page: 10,
      page: 0,
      filters: {},
      merge_filters: {},
      showDialog: false,
      showPreview: false,
      current_id: undefined,
      anchorEl: null, // for popover
    }
  }

  componentWillMount() {
  // componentWillMount() {

    if (this.props.init_filters) {
      this.setState({filters: this.props.init_filters})
    }
    if (this.props.init_sort) {
      this.setState({sort: this.props.init_sort})
    }
    if (this.props.init_order) {
      this.setState({order: this.props.init_order})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const newReq = {
      filters: this.state.filters,
      merge_filters: this.state.merge_filters,
      sort: this.state.sort,
      order: this.state.order,
      page: this.state.page,
      per_page: this.state.per_page
    }
    const oldReq = {
      filters: prevState.filters,
      merge_filters: prevState.merge_filters,
      sort: prevState.sort,
      order: prevState.order,
      page: prevState.page,
      per_page: prevState.per_page
    }
    if (JSON.stringify(prevProps.merge_filters) !== JSON.stringify(this.props.merge_filters)) {
      return this.setState({
        merge_filters: this.props.merge_filters,
        page: 1
      })
    }
    if (JSON.stringify(newReq) !== JSON.stringify(oldReq)) {
      const {page, per_page, filters, sort, order} = this.state
      const {merge_filters} = this.props
      const all_filters = {
        ...filters,
        ...merge_filters
      }
      this.props.rowGetter(page, per_page, all_filters, sort, order)
      if (this.props.getGlobalFilters) {
        this.props.getGlobalFilters(all_filters, sort, order)
      }
    }

  }

  handlePopoverOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null });
  };

  handlePopoverClick = event => {
    if (this.state.anchorEl === null) {
      this.setState({ anchorEl: event.currentTarget });
      window.setTimeout(function(self){
        self.setState({ anchorEl: null })
      }, 2000, this)
    }
  };

  handleSelectAllClick = event => {
    if (event.target.checked) {
      this.setState(state => ({ selected: state.data.map(n => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  }

  handleRequestSort = (event, property) => {
    const sort = property;
    let order = 'desc';

    if (this.state.sort === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, sort });
  }

  handleChangePage = (event, page) => {
    const new_page = page + 1
    this.setState({ page: new_page})
  };

  handleChangeRowsPerPage = event => {
    const { value } = event.target
    this.setState({ per_page: value, page: 1 });
  };

  handleFilter = field => event => {
    if (field === "search") {
      if (event.target.value && event.target.value.length > 2) {
        this.setState({
          filters: {
            ...this.state.filters,
            search: event.target.value
          }
        })
      } else {
        const { search, ...other } = this.state.filters
        this.setState({
          filters: {
            ...other,
          }
        })
      }
    }
    this.setState({
      filters: {
        ...this.state.filters,
        [field]: event.target.value
      }
    })
  }

  clearFilters = () => {
    if (this.picker && this.picker.current) {
      this.picker.current.resetDates()
    }
    this.setState({
      filters: {
        active: this.state.filters.active,
        trash: this.state.filters.trash
      }
    })
  }

  handleDates = (dates, prefix="") => {
    const {from, to} = dates
    this.setState({
      filters: {
        ...this.state.filters,
        [`${prefix}from`]: from !== null && from._isValid ? moment(from).startOf('day').utc().format() : null,
        [`${prefix}to`]: to !== null && to._isValid ? moment(to).endOf('day').utc().format() : null,
      }
    })
  }

  render() {
    const {
      classes, columns, headerButton,
      userRole, rows, pagination, fieldGetter, filterControls,
      statuses, current_view, handleStatus,
      previewColumn, previewColumns, clearItem, previewItem,
      displayPreviewIf, classPrefix, addClassField,
      search
    } = this.props

    const validColumns = columns.map( c => c.id ) // Map of column names

    const { sort, order, selected, filters } = this.state

    const StatusHref = props => {
      return (
        <a href='' className={current_view === props.view ? 'active_view' : ''} onClick={e => {
          e.preventDefault()
          handleStatus(props.view)
        }}>
          {props.label} ({props.value})
        </a>
      )
    }

    // popover
    const { anchorEl } = this.state;
    const anchorOpen = Boolean(anchorEl);

    const searchField = (
        <Grid container item md={12} justify="flex-end" alignItems="flex-end" className="instatable-search">
          <Grid item className="instatable-search-field">
            <FilterSelect
              filter_type="search"
              filters={filters}
              className="filter-selects body2 c-black087 no-sudo-hover filter-selects-search mr-8"
              name="search"
              onChange={this.handleFilter.bind(this)}
              placeholders={this.props.placeholders}
            />
          </Grid>
          <Grid item className="mr-8 instatable-search-tip">
            <Icon
              onMouseEnter={this.handlePopoverOpen}
              onMouseLeave={this.handlePopoverClose}
              onClick={this.handlePopoverClick}
              >help</Icon>
            <Popover
              handlePopoverClose={this.handlePopoverClose.bind(this)}
              open={anchorOpen}
              anchorEl={anchorEl}
              text={`Search in: ${this.props.placeholders}`}
            />
          </Grid>
        </Grid>
    )

    return (

      <React.Fragment>

        <Grid container spacing={24} justify="space-between" alignItems="flex-end">
          <Hidden smDown>
            { search && searchField }
          </Hidden>
          <Grid item md={12}>
            <Typography id="statuses" color="primary" className="statuses inline-filters">
              {
                statuses.map( s => {
                  return <StatusHref key={s.name} view={s.name} label={s.label} value={s.value} />
                })
              }
              {
                headerButton !== undefined && headerButton(
                  {...this.state.filters, ...this.props.merge_filters},
                  this.state.sort,
                  this.state.order
                )
              }
            </Typography>
          </Grid>
          <Hidden mdUp>
            { search && searchField }
          </Hidden>
        </Grid>

        <Hidden mdUp>
          <MobileFilters
            filters={this.state.filters}
            filterControls={filterControls.filter( s => s.name !== 'search')}
            handleFilter={this.handleFilter.bind(this)}
            clearFilters={this.clearFilters.bind(this)}
            handleDates={this.handleDates.bind(this)}
            picker={this.picker}
          />
        </Hidden>
        {
          (!this.props.hideFilters && (
            <Hidden smDown>
              <div className="mt-8 mb-16 d-flex align-items-end">
                <div className="body2 d-inline-block c-black087 mr-24">Filter by:</div>

                {
                   filterControls.map( (fc, index) => {
                     if (fc.filter_type === "search") {
                       return this.props.search ? '' : (
                         <FilterSelect
                           key={`filter_${index}`}
                           filter_type="search"
                           filters={filters}
                           name={fc.name}
                           onChange={this.handleFilter.bind(this)}
                           placeholders={this.props.placeholders}
                         />
                       )
                     } else if (fc.filter_type === "date") {
                       return (
                         <span key={`filter_${index}`} className={(index !== filterControls.length - 1) ? "mr-24" : ""}>
                           <CustomRangePicker
                             handleChange={ dates => {
                               this.handleDates(dates, fc.prefix || "")
                             }}
                             startLabel={fc.startLabel}
                             endLabel={fc.endLabel}
                             ref={this.picker}
                           />
                         </span>
                       )
                     } else {
                       return (
                         <FilterSelect
                           key={`filter_${index}`}
                           filters={filters}
                           name={fc.name}
                           label={fc.label}
                           onChange={this.handleFilter.bind(this)}
                           collection={fc.collection}
                           valueField={fc.valueField}
                         />
                       )
                     }
                   })
                }

                <div className="ml-24 d-flex align-items-center c-black054 pointer body2" onClick={this.clearFilters.bind(this)}>
                  <Icon className="mr-8">cancel</Icon>
                    Clear
                </div>
              </div>
            </Hidden>
          )) || <div className="mt-8 mb-16 d-flex align-items-end" />
        }

        <Paper className={classes.root}>
          <div className="table-responsive">
            <Table className={classes.table}>
              <CustomTableHead
                rows={columns}
                numSelected={selected.length}
                sort={sort}
                order={order}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={rows.length}
                userRole={userRole}
              />
              <TableBody>
                {
                  (rows.length === 0) ? (
                    <TableRow>
                      <TableCell colSpan={columns.length}>No items to display</TableCell>
                    </TableRow>
                  ) : rows.map( item => {
                    const {id} = item
                    let addClass = ''
                    if (classPrefix !== undefined && addClassField !== undefined && item[addClassField] !== undefined) {
                      addClass=`${classPrefix}_${item[addClassField]}`
                    }

                    return (
                      <TableRow key={id} className={classNames(classes.row, addClass)}>
                        {
                          validColumns.map( field => {
                            const renderText = fieldGetter(field, item, this.state)

                            let showRenderIcon = true
                            if ( displayPreviewIf && displayPreviewIf[field]) {
                              const conditions = displayPreviewIf[field]
                              Object.keys(conditions).forEach( k => {
                                if (item[k] !== conditions[k]) {
                                  showRenderIcon = false
                                }
                              })
                            }

                            const renderIcon = ( showRenderIcon && (field === previewColumn || (previewColumns && previewColumns[field] !== undefined) ) ) ? (
                              <Icon style={{
                                  cursor: "pointer",
                                  color: "rgba(0,0,0,.87)",
                                  fontSize: '16px',
                                }}>{ (previewColumns && previewColumns[field] !== undefined) ? previewColumns[field] : 'remove_red_eye' }</Icon>
                            ) : ""

                            if (field === "actions") {
                              return (
                                <TableCell key={`${id}-actions`} style={{
                                  whiteSpace: 'nowrap'
                                }}>
                                  {renderText}
                                </TableCell>
                              )
                            }
                            const minWidth = columns.find( c => c.id === field ).minWidth

                            return (
                              <TableCell className={(field === previewColumn || (previewColumns && previewColumns[field] !== undefined)) ? "hoverIcon" : ''} key={`${id}-${field}`} onClick={e=>{
                                 e.preventDefault()
                                 if (field === previewColumn ) {
                                   if (clearItem) {
                                     clearItem()
                                   }
                                   previewItem(item, field, this.state)
                                 }
                                }}>
                                <div className="relative" style={ minWidth ? {minWidth: minWidth} : {}}>
                                  <div style={{maxWidth: "85%"}}>{renderText}</div>
                                  <div style={{position: "absolute", top: "50%", transform: "translateY(-50%)", right: "10%"}}>
                                    {renderIcon}
                                  </div>
                                </div>
                              </TableCell>
                            )
                          })
                        }

                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </div>
          {
            pagination.total ? (
              <CustomTablePagination
                component="div"
                count={pagination.total}
                rowsPerPage={pagination.per_page}
                page={(pagination.page ) - 1}
                backIconButtonProps={{
                  'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'Next Page',
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            ) : ''
          }
        </Paper>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(InstaTable)



// WEBPACK FOOTER //
// ./src/js/components/InstaTable.js